module.exports = require("@sentry/react");